export default __webpack_public_path__ + "static/GolosText-Regular-6e4f82c2d2f3ff984bc635fea1aa15d6.ttf";